import { Controller } from '@hotwired/stimulus';

export default class InlineAdminFormsetController extends Controller {
  static values = {
    fields: { type: Array, default: [] },
  };

  connect() {
    // Use MutationObserver to watch for changes in the inline group element
    this.observer = new MutationObserver(this.handleMutations.bind(this));
    this.observer.observe(this.element, { childList: true, subtree: true });
  }

  disconnect() {
    // Disconnect the observer when the controller is disconnected
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  handleMutations(mutations) {
    mutations.forEach((mutation) => {
      // Check if nodes were added
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          // If a new "Add another" button or inline form was added, handle it
          if (node.nodeType === 1 && node.matches('.add-row')) {
            // Find the link within the "add-row" container and add an event listener to it
            const addButton = node.querySelector('a');
            if (addButton) {
              addButton.addEventListener('click', (event) =>
                this.addRowHandler(event),
              );
            }
          }
        });
      }
    });
  }

  addRowHandler(event) {
    // Wait to make sure the new form is added to the DOM before manipulating it
    setTimeout(() => {
      // Find all inline forms excluding the empty form
      let inlineForms = this.element.querySelectorAll(
        '.form-row:not(.empty-form)',
      );
      let newForm = inlineForms[inlineForms.length - 1];

      // Ensure the new form exists
      if (newForm) {
        // Iterate through each field and set the default value (if applicable)
        this.fieldsValue.forEach((field) => {
          // Set default value for input elements
          const inputField = newForm.querySelector(
            `input[name$="-${field.name}"]`,
          );
          if (inputField) {
            inputField.value = field.value;
          }

          // Set default value for select elements
          const selectField = newForm.querySelector(
            `select[name$="-${field.name}"]`,
          );
          if (selectField) {
            selectField.value = field.value;
          }
        });
      }
    }, 100); // Wait a little longer to ensure the new form is fully added to the DOM
  }
}
